module.exports = __webpack_public_path__ + "img/IMG_1634.52c8ba81.jpeg";